import { BanModal } from './BanModal'
import { withBanModal } from './withBanModal'

const ConnectedBanModal = withBanModal(BanModal)

export { ConnectedBanModal as BanModal }
